import {Anchor} from 'src/design/atoms/Anchor';
import {Group} from 'src/design/atoms/Group';
import React from 'react';
import type {AttachmentSimpleResponse} from 'src/api/ProactApiClient';
import {splitAttachmentsByImage} from 'src/app/inspections/attachmentHelpers';
import {useAttachmentUrls} from 'src/offline/useAttachmentUrl';
import {ThumbnailStrip} from 'src/design/molecules/ThumbnailStrip';

export interface AttachmentGalleryProps {
  attachments: AttachmentSimpleResponse[];
  /** Extra images to append after the resolved attachments (e.g. offline captures). */
  extraImages?: {src: string; alt: string}[];
}

/** Image thumbnails + plain file links for a set of attachments, resolving
 * offline-cached blobs where present. Shared by the record flow and history. */
export const AttachmentGallery: React.FC<AttachmentGalleryProps> = ({
  attachments,
  extraImages = [],
}) => {
  const urls = useAttachmentUrls(attachments);
  const {images, files} = splitAttachmentsByImage(attachments);
  const imageItems = [
    ...images.map(attachment => ({
      src: urls[attachment.key] ?? '',
      alt: attachment.name,
    })),
    ...extraImages,
  ];

  return (
    <>
      {imageItems.length > 0 && <ThumbnailStrip items={imageItems} />}
      {files.length > 0 && (
        <Group gap="xs">
          {files.map(attachment => (
            <Anchor
              key={attachment.id}
              href={urls[attachment.key] ?? ''}
              target="_blank"
              rel="noreferrer"
              size="xs">
              {attachment.name}
            </Anchor>
          ))}
        </Group>
      )}
    </>
  );
};
